const CURRENT_STATUS_URL = process.env.API_URL + '/current-status/';

const getCurrentStatus = (context, globalTags, groupTags) => {
  return context.$http.get(CURRENT_STATUS_URL, {params: {globalTags: globalTags, groupTags: groupTags}});
};

export default {
  getCurrentStatus
};



// WEBPACK FOOTER //
// ./src/api/currentStatus/currentStatusHttp.js